import { AppDispatch } from "app/store";
import OmronFooter from "components/OmronFooter";
import OmronHeader from "components/OmronHeader";
import PageTitle from "components/PageTitle";
import { changeCode, changeEmail, verifyAsync } from "features/verifyUser";
import {
  selectCode,
  selectEmail,
  selectExecuteState,
} from "features/verifyUser/selectors";
import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const VerifyUserPage: React.FC = (): JSX.Element => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const email = useSelector(selectEmail);
  const executeState = useSelector(selectExecuteState);
  const code = useSelector(selectCode);

  useEffect(() => {
    if (executeState === "success") {
      navigate("/verifyUser/complete");
    }
  });

  const onSubmit = useCallback(() => {
    dispatch(verifyAsync({ code, email }));
  }, [code, dispatch, email]);

  // const email = useSelector(selectEmail);
  return (
    <MainWrapper>
      <OmronHeader
        link={{ path: "/", label: t("common.label.breadcrumbsSignin") }}
        label={[
          t("common.label.breadcrumbsSignup"),
          t("common.label.breadcrumbsSignupConf"),
          t("common.label.breadcrumbsVerifyUser"),
        ]}
      />
      <PageMain>
        <InnerDiv>
          <PageTitle
            title={t("verifyUser.label.title")}
            text={t("verifyUser.text.verifyDescription")}
          />
          <form>
            <VerifyCodeDl>
              <VerifyCodeDd>
                {t("verifyUser.label.verifyCode")}
                <VerifyCodeInput
                  type="text"
                  size={6}
                  maxLength={6}
                  value={code}
                  onChange={(e) => {
                    dispatch(changeCode({ code: e.target.value }));
                  }}
                />
              </VerifyCodeDd>
              <VerifyCodeDd2>
                {t("verifyUser.label.email")}
                <VerifyEmailInput
                  name="email"
                  type="email"
                  size={60}
                  onChange={(event) =>
                    dispatch(changeEmail({ email: event.target.value }))
                  }
                />
              </VerifyCodeDd2>
              <VerifyCodeDd>
                <VerifyButton
                  type="button"
                  value={t("verifyUser.label.verifyButton")}
                  onClick={onSubmit}
                />
              </VerifyCodeDd>
            </VerifyCodeDl>
          </form>
        </InnerDiv>
      </PageMain>
      <OmronFooter />
    </MainWrapper>
  );
};

export default VerifyUserPage;

const MainWrapper = styled.div`
  display: grid;
  grid-template-rows: 76px 40px 1fr auto;
  grid-template-areas:
    "header"
    "breadc"
    "main"
    "footer";
  min-height: 100vh;
`;
const PageMain = styled.main`
  grid-area: main;
  padding: 3.2rem 50px;
`;

const InnerDiv = styled.div`
  width: 1000px;
  margin: 0 auto;
`;
const VerifyCodeInput = styled.input`
  width: 6rem;
  padding: 0.5rem 1.3rem;
  margin-bottom: 1rem;
  border: 1px #999999 solid;
  font-size: 1.71rem;
  line-height: 2rem;
  letter-spacing: 0.07rem;
  font-weight: normal;
  margin-right: 19.9rem;
  margin-left: 1.2rem;
`;
const VerifyEmailInput = styled.input`
  width: 26rem;
  padding: 1rem 1.3rem;
  margin-bottom: 1rem;
  border: 1px #999999 solid;
  font-size: 1.4rem;
  line-height: 1rem;
  letter-spacing: 0.07rem;
  font-weight: small;
  margin-left: 3.5rem;
  :focus {
    outline: 0;
    background: #fafafa;
  }
`;
const VerifyButton = styled.input`
  width: 15rem;
  padding: 1.23rem 2rem;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  pointer-events: none;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  cursor: pointer;
  opacity: 1;
  color: #ffffff;
  background: #005eb8;
  border: 1px #005eb8 solid;
  pointer-events: auto;
  :hover {
    background: rgba(0, 94, 184, 0.7);
  }
`;
const VerifyCodeDl = styled.dl`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 3rem;
`;
const VerifyCodeDd = styled.dd`
  width: 100%;
  background: none;
  text-align: center;
  padding: 1rem 0;
`;
const VerifyCodeDd2 = styled.dd`
  width: 100%;
  background: none;
  text-align: center;
  padding: 1rem 0;
`;
